<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="part">
<header>
<h1 class="topictitle1" id="pa5"><a href="#/nav#npa5"><span class="section_number">PART 1</span><br/><span class="title">THE ROACH BOY OF MOUND CAJORIA, A HUMAN-INHABITED ANT COLONY OF THE GREAT AND HOLY SLOPE </span></a></h1>
</header>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Part_1.vue?5c323521